const getExistsAcc = async () => {

    return [
        {'code': 1, 'name': 'Бор'},
        {'code': 0, 'name': 'Йўқ'},
    ]

};
export default getExistsAcc;